"use client"

import { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import {
  Home,
  Clipboard,
  Users,
  Package,
  LogIn,
  UserPlus,
  Menu,
  X,
  LogOut,
  Settings,
  FileText,
  BarChart2 ,
} from "react-feather"

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true)
  const [isMobile, setIsMobile] = useState(false)
  const location = useLocation()

  // Check if user is logged in
  const isLoggedIn = localStorage.getItem("userToken") !== null
  // Check if user is admin (this is a simple check, you might need to adjust based on your auth logic)
  const isAdmin = isLoggedIn // Simplified for now, you can add more specific logic

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
      if (window.innerWidth < 768) {
        setIsOpen(false)
      } else {
        setIsOpen(true)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }

  const handleLogout = () => {
    localStorage.removeItem("userToken")
    window.location.href = "/"
  }

  const NavItem = ({ to, icon: Icon, label, onClick }) => {
    const isActive = location.pathname === to

    return (
      <li>
        <Link
          to={to}
          onClick={onClick}
          className={`flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group ${
            isActive ? "bg-gray-100 font-medium" : ""
          }`}
        >
          <Icon
            className={`w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 ${
              isActive ? "text-gray-900" : ""
            }`}
          />
          <span className="ms-3">{label}</span>
        </Link>
      </li>
    )
  }

  return (
    <>
      {/* Mobile menu button */}
      <button
        onClick={toggleSidebar}
        type="button"
        className="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
      >
        <span className="sr-only">Open sidebar</span>
        {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 z-40 w-64 h-screen transition-transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0`}
        aria-label="Sidebar"
      >
        <div className="h-full px-3 py-4 overflow-y-auto bg-white border-r">
          <div className="flex items-center justify-between mb-5 px-2">
            <Link to="/" className="flex items-center">
              <span className="self-center text-xl font-semibold">MedTrack</span>
            </Link>
            {isMobile && (
              <button onClick={toggleSidebar} type="button" className="text-gray-500 hover:text-gray-900">
                <X className="w-5 h-5" />
              </button>
            )}
          </div>

          <ul className="space-y-2 font-medium">
            <NavItem to="/Home" icon={Home} label="Dashboard" />

            {isAdmin && (
              <>
                <NavItem to="/approvals" icon={Clipboard} label="Approvals" />
                <NavItem to="/active" icon={Users} label="Active Users" />
                <NavItem to="/AllProducts" icon={Package} label="Products" />
                <NavItem to="/content-management" icon={FileText} label="Content Management" />
                <NavItem to="/analytics" icon={BarChart2 } label="Analytics" />
              </>
            )}

            {isLoggedIn && (
              <>
                
                <NavItem to="/settings" icon={Settings} label="Settings" />
                <li>
                  <button
                    onClick={handleLogout}
                    className="flex items-center w-full p-2 text-gray-900 rounded-lg hover:bg-gray-100 group"
                  >
                    <LogOut className="w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900" />
                    <span className="ms-3">Logout</span>
                  </button>
                </li>
              </>
            )}

            {!isLoggedIn && (
              <>
                <NavItem to="/" icon={LogIn} label="Login" />
                <NavItem to="/signup" icon={UserPlus} label="Sign Up" />
              </>
            )}
          </ul>
        </div>
      </aside>

      {/* Overlay for mobile */}
      {isOpen && isMobile && (
        <div className="fixed inset-0 z-30 bg-gray-900 bg-opacity-50 md:hidden" onClick={toggleSidebar} />
      )}
    </>
  )
}

export default Sidebar
